import { useQuery } from '@tanstack/react-query';
import { countries, getEmojiFlag } from 'countries-list';
import type { TCountryCode } from 'countries-list';
import { Country } from '@/types/location';
import { debugLogger } from '@/utils/debugLogger';

// Priority countries to show first
const PRIORITY_COUNTRIES = ['BR', 'US', 'PT', 'AR', 'MX', 'CO', 'CL', 'PE', 'ES', 'FR', 'GB', 'DE', 'IT', 'CA'];

export const useGlobalCountries = () => {
  return useQuery({
    queryKey: ['global-countries'],
    queryFn: (): Country[] => {
      debugLogger.debug('useGlobalCountries', 'Loading countries from static data...');
      
      // Objeto JS estático - execução instantânea, sem await
      const countryList: Country[] = Object.entries(countries).map(([code, data]) => ({
        code,
        name: data.name,
        flag: getEmojiFlag(code as TCountryCode),
        phoneCode: Array.isArray(data.phone) ? data.phone.join(',') : String(data.phone),
      }));

      // Sort: priority countries first, then alphabetically
      const sortedCountries = countryList.sort((a, b) => {
        const aIndex = PRIORITY_COUNTRIES.indexOf(a.code);
        const bIndex = PRIORITY_COUNTRIES.indexOf(b.code);
        
        if (aIndex !== -1 && bIndex !== -1) {
          return aIndex - bIndex;
        }
        if (aIndex !== -1) return -1;
        if (bIndex !== -1) return 1;
        
        return a.name.localeCompare(b.name);
      });

      debugLogger.debug('useGlobalCountries', `Loaded ${sortedCountries.length} countries`);
      return sortedCountries;
    },
    staleTime: Infinity, // Never refetch - static data
    gcTime: Infinity, // Keep in cache forever
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
